/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as S from './SpecificVersionsSection.styled';
import ChooseSpecificVersionsBtn from '../specificVersionsBtn/ChooseSpecificVersionsBtn';
import {
  selected_os_versions,
  select_userAgentsOSList,
  selectTargettingErrorFlag,
} from 'store/selectors';
import { DeleteIcon } from 'assets/icons';
import { Buttons, ErrorForBtn, IconButton } from 'components';
import Separator from 'components/common/Separator.js';
import { generalActions } from 'store/actions';

export const alphabeticallySort = (a, b) => {
  if (+a.label < +b.label) {
    return -1;
  }
  if (+a.label > +b.label) {
    return 1;
  }
  return 0;
};

const SpecificVersions = () => {
  const dispatch = useDispatch();
  const selected_versions = useSelector(selected_os_versions);
  const selected_os_versions_numbers = useSelector(select_userAgentsOSList);
  const errorFlag = useSelector(selectTargettingErrorFlag);

  const handleClickBtnX = (value) => {
    const res = selected_os_versions_numbers.filter((v) => v !== value);
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSList',
        newValue: res.join(','),
      }),
    );
    dispatch(generalActions.setMinBidAsNotRelevant());
  };
  const clearAllBtnClick = () => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSList',
        newValue: '',
      }),
    );
    dispatch(generalActions.setMinBidAsNotRelevant());
  };

  useEffect(() => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSNameList',
        newValue: selected_versions.map((item) => item.label).join(','),
      }),
    );
  }, [selected_versions]);

  return (
    <>
      <S.Container showErrorBorder={errorFlag.os}>
        <S.BtnWrap>
          <ChooseSpecificVersionsBtn />
        </S.BtnWrap>
        {selected_versions.length ? (
          <>
            <Separator />
            <S.SelectedItems>
              <Buttons.TertiaryNormal id='choose_apps_clear_all' onClick={clearAllBtnClick}>
                Clear All
              </Buttons.TertiaryNormal>
              <S.SelectedItemsList>
                {[...selected_versions]?.sort(alphabeticallySort)?.map(({ value, label }) => {
                  return (
                    <S.SelectedItem key={value}>
                      {label}
                      <IconButton.SmallSize
                        isDefaultMuted
                        icon={DeleteIcon}
                        type={IconButton.btnTypes.tertiary}
                        onClick={() => handleClickBtnX(value)}
                      />
                    </S.SelectedItem>
                  );
                })}
              </S.SelectedItemsList>
            </S.SelectedItems>
          </>
        ) : null}
      </S.Container>
      <ErrorForBtn
        errorMsg='Please choose Versions or select "Minimum Version".'
        isOpen={errorFlag.os}
      />
    </>
  );
};

export default SpecificVersions;
